import React from "react";
import { type BalanceRowProps } from "utils/types/wallet.type";

export default function BalanceRow({ wallet }: BalanceRowProps) {
  return (
    <tr className="bg-white hover:bg-gray-50">
      <td className="py-3 px-4 border border-gray-300">
        <div className="flex items-center gap-2">
          {wallet.coinLogoUrl ? (
            <img
              src={wallet.coinLogoUrl}
              alt={wallet.coinName}
              className="w-6 h-6 rounded-full"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          ) : (
            <div className="w-6 h-6 rounded-full bg-gray-300"></div>
          )}
          <div>
            <p className="text-black-900 text-sm font-medium">
              {wallet.coinName}
            </p>
            <p className="text-black-700 text-xs">{wallet.symbol}</p>
          </div>
        </div>
      </td>
      <td className="py-3 px-4 border border-gray-300">
        <p className="text-black-900 text-sm">{wallet.networkName}</p>
      </td>
      <td className="py-3 px-4 text-right border border-gray-300">
        <p className="text-black-900 text-sm font-medium">
          {wallet.balance_formatted}
        </p>
      </td>
      <td className="py-3 px-4 text-right border border-gray-300">
        <p className="text-black-900 text-sm font-medium">
          ${wallet.balanceInUsd.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </td>
    </tr>
  );
}

